const STORAGE_KEY = 'sensevib_user_settings'
const LAST_NODE_MIGRATION_KEY = 'last_node_storage_v2_migrated'

function readSettings() {
    if (typeof window === 'undefined' || !window.localStorage) {
        return {}
    }
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY)
        return raw ? JSON.parse(raw) : {}
    } catch (error) {
        void error
        // Ignore malformed or unavailable localStorage.
        return {}
    }
}

function writeSettings(settings) {
    if (typeof window === 'undefined' || !window.localStorage) {
        return
    }
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
    } catch (error) {
        void error
        // Ignore quota or privacy-mode write failures.
    }
}

export function getUserSetting(key, defaultValue) {
    const settings = readSettings()
    return Object.prototype.hasOwnProperty.call(settings, key) ? settings[key] : defaultValue
}

export function setUserSetting(key, value) {
    const settings = readSettings()
    settings[key] = value
    writeSettings(settings)
}

// 最后访问的节点属于全局导航状态，不应跟随设置窗口添加 _1、_2 后缀。
// 旧版本曾误存为 last_node_1；首次读取时自动迁移，保留用户已有记录。
export function getLastNodeSetting(defaultValue = null) {
    const current = getUserSetting('last_node', null)
    if (!getUserSetting(LAST_NODE_MIGRATION_KEY, false)) {
        // 带后缀的记录由旧缺陷持续更新，通常比旧的全局记录更新，因此
        // 迁移时优先采用它；迁移只执行一次，之后全部使用全局键。
        const legacy = getUserSetting('last_node_1', null)
        const migrated = legacy && legacy.node ? legacy : current
        if (migrated && migrated.node) {
            setUserSetting('last_node', migrated)
        }
        setUserSetting(LAST_NODE_MIGRATION_KEY, true)
        return migrated || defaultValue
    }
    return current && current.node ? current : defaultValue
}

export function setLastNodeSetting(value) {
    setUserSetting('last_node', value)
    setUserSetting(LAST_NODE_MIGRATION_KEY, true)
}



// WEBPACK FOOTER //
// ./src/utils/userSettings.js